import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "dialog", "closeButton", "submitButton", "submitBeeButton", "dialogForm", "fieldType", "deleteButton", "spotsSwitch", "spotsInput", "acceptCookies", "iframe"]
  static values = { embedUrl: String }

  initialize () { 
    let _this = this,
        form_changed = false;

    if (_this.hasDialogTarget) {

      let dialog = _this.dialogTarget;
          
      if (_this.hasSubmitBeeButtonTarget ) {
        _this.submitBeeButtonTarget.addEventListener('click', function() {
          // Custom event we will use as our trigger
          const trigger = new CustomEvent("trigger-save");
          window.dispatchEvent(trigger);
        });
      }

      if (_this.hasDialogFormTarget && _this.hasSubmitButtonTarget) {
        let form = _this.dialogFormTarget;

        form.addEventListener("input", function () {
          if (_this.hasCloseButtonTarget) {
            form_changed = true;
            _this.submitButtonTarget.classList.remove('hidden');
          }
        });

        form.addEventListener("turbo:submit-end", function (event) { 
          if (event.detail.success)
            _this.close();
        });

        if (_this.hasFieldTypeTarget ) {
          _this.fieldTypeTarget.addEventListener('change', function() {
            form.setAttribute("field-type", _this.fieldTypeTarget.value)
          });
        }

      }

      if (_this.hasDeleteButtonTarget ) {
        _this.deleteButtonTarget.addEventListener("click", function (event) { 
          if (!confirm(_this.deleteButtonTarget.dataset.confirm)) { 
            event.preventDefault(); 
          } else {
            _this.close();
          }
          
        });

      }

      if (_this.hasSpotsSwitchTarget && _this.hasSpotsInputTarget) {


        _this.spotsSwitchTarget.addEventListener('change', function() {
          console.log(_this.spotsSwitchTarget.selected);

          if (_this.spotsSwitchTarget.selected) {
            _this.spotsInputTarget.style.display = "block";
            _this.spotsInputTarget.focus();
          } else {
            _this.spotsInputTarget.style.display = "none";
            _this.spotsInputTarget.value = 0;

          }

        });

          
        

      }

      dialog.addEventListener('cancel', function(event) {
        console.log("prevent cancel", dialog.classList.contains("prevent-cancel"));
        if (form_changed || dialog.classList.contains("prevent-cancel")) {
          event.preventDefault();
          console.log("Dialog cancel");
        }

      });

      dialog.addEventListener("close", function() {
        _this.stopPlayback();
      });
      dialog.addEventListener("closed", function() {
        _this.stopPlayback();
      });

      if (_this.hasCloseButtonTarget ) {
        _this.closeButtonTarget.addEventListener('click', function() {
          _this.close();
        });
      }


      if (_this.hasAcceptCookiesTarget ) {
        _this.acceptCookiesTarget.addEventListener('click', function() {
          document.cookie = "cookies-accepted=true"

          _this.close();
        });
      }

    }

  }

  open(event) {
    if (event) event.preventDefault();
    if (!this.hasDialogTarget) return;

    if (typeof this.dialogTarget.show === "function") {
      this.dialogTarget.show();
    } else {
      this.dialogTarget.open = true;
    }

    // Set src right after opening to preserve user gesture for autoplay policies.
    this.setIframeSource();
  }

  close(event) {
    if (event) event.preventDefault();
    if (!this.hasDialogTarget) return;

    if (typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close();
    } else {
      this.dialogTarget.open = false;
    }

    this.stopPlayback();
  }

  setIframeSource() {
    if (!this.hasIframeTarget || !this.hasEmbedUrlValue) return;
    this.iframeTarget.src = this.autoplayUrl(this.embedUrlValue);
  }

  stopPlayback() {
    if (this.hasIframeTarget) this.iframeTarget.src = "";
  }

  autoplayUrl(url) {
    try {
      const parsedUrl = new URL(url);
      parsedUrl.searchParams.set("autoplay", "1");
      if (this.isYouTubeEmbed(parsedUrl)) {
        parsedUrl.searchParams.set("mute", "1");
        parsedUrl.searchParams.set("playsinline", "1");
      }
      return parsedUrl.toString();
    } catch (error) {
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}autoplay=1`;
    }
  }

  isYouTubeEmbed(parsedUrl) {
    const host = parsedUrl.host.toLowerCase();
    return host.includes("youtube.com") || host.includes("youtube-nocookie.com") || host === "youtu.be";
  }

}
